(function () {
  var SELECTOR = [
    '[class*="__wrapper"]',
    '.nhp-rr-container'
  ].join(',');

  var EXCLUDE = [
    '.nhp-hd__inner',
    '.nhp-ft-container',
    '.home-hero__wrapper'
  ];

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    var nodes = Array.prototype.slice.call(document.querySelectorAll(SELECTOR));
    var targets = nodes.filter(function (el) {
      return !EXCLUDE.some(function (sel) { return el.matches(sel); });
    });

    if (!targets.length) return;

    if (!('IntersectionObserver' in window)) {
      targets.forEach(function (el) { el.classList.add('sr-reveal', 'is-visible'); });
      return;
    }

    targets.forEach(function (el) { el.classList.add('sr-reveal'); });

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });

    targets.forEach(function (el) { io.observe(el); });
  });
})();
